
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Luxuryforceurbaniaonrentinpune() {



  const cardData =
  {
    keyword: ' Luxury Force Urbania on Rent in Pune',
    heading: 'Vaishnavi Travels: Luxury Force Urbania on Rent in Pune',
    headingDescription: 'Vaishnavi Travels offers premium Luxury Force Urbania on Rent in Pune, designed to provide a first-class travel experience for families, corporate groups, and special occasions. Our Luxury Urbania comes equipped with plush push-back seats, powerful air-conditioning, modern interiors, and ample luggage space to ensure a smooth and comfortable journey. Perfect for weddings, business trips, outstation tours, and VIP travel, this vehicle combines luxury with convenience. With professional chauffeurs, timely service, and flexible booking options, Vaishnavi Travels guarantees a safe, stylish, and hassle-free ride every time you choose our Luxury Force Urbania rental service in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace and a proud symbol of Maratha power. Once the seat of the Maratha Empire, its massive gates, sprawling gardens, and ruins narrate tales of valor. Though partially destroyed by a fire in 1828, it still draws thousands of visitors every day. The evening light-and-sound show brings alive the love story of Bajirao and Mastani and the grandeur of the Peshwas. Its corridors, courtyards, and fountains carry echoes of Maratha history. Shaniwar Wada remains Pune’s most cherished cultural landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, the Aga Khan Palace is one of Pune’s most historic monuments linked to India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, the palace houses a museum displaying Gandhi’s personal belongings, letters, and photographs. Its Italian arches and sprawling gardens add architectural charm and peaceful vibes. Tourists enjoy strolling through its lawns while reflecting on history. Aga Khan Palace is Pune’s inspirational symbol of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a legendary hill fort known for the 1670 battle where Tanaji Malusare fought valiantly for Chhatrapati Shivaji Maharaj. Perched atop a hill, it offers breathtaking panoramic views of the Sahyadris and trekking trails loved by adventurers. The fort still houses bastions, memorials, and temples that narrate Maratha bravery. During monsoon, mist and waterfalls enhance its charm. Visitors also relish rustic delicacies like pithla-bhakri at local stalls. Sinhagad Fort is Pune’s perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established over 125 years ago, it houses a magnificent idol adorned with gold and ornaments. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities attracting lakhs of devotees. Known for its charitable and cultural initiatives, it serves as both a spiritual and social hub. The temple’s vibrant aura captivates tourists and locals alike. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, sanctum chambers, and a Nandi mandapa. Despite being in the city center, it offers peace and meditation amidst the chaos. Evening prayers and chants add to its mystical ambiance. The temple reflects ancient Indian craftsmanship and architectural skill. Pataleshwar Cave Temple is Pune’s hidden gem of spiritual heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting the romance of Maratha history. Students and history enthusiasts find it deeply educational and fascinating. The museum preserves centuries of traditions and artistry under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers panoramic views of the city from its temple complex. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller temples and a museum add depth to the visit. Pilgrims and tourists climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global hub for wellness, spirituality, and mindfulness. Spread across lush gardens, it attracts seekers and tourists from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Japanese Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for relaxation and rejuvenation. Osho Ashram is Pune’s international center of peace and healing."
  },
  {
    "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With flowing streams, stone bridges, and manicured lawns, it is a paradise for nature lovers. Families enjoy picnics, photography, and peaceful walks here. The garden symbolizes Indo-Japanese friendship and cultural exchange. Seasonal flowers add color and charm throughout the year. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s popular weekend getaway. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates spectacular views. Families enjoy roadside snacks like roasted corn and tea by the banks. It also serves as the gateway to Sinhagad Fort nearby. Khadakwasla Dam is Pune’s refreshing natural retreat for relaxation and leisure."
  }
],

"services": [
  {
    "name": "Luxury Urbania Hire Pune",
    "description": "Experience top-tier travel with our Luxury Urbania Hire service in Pune, perfect for those who want sophistication, comfort, and efficiency in their journey. The Force Urbania offers spacious interiors, plush reclining seats, individual air conditioning vents, ambient lighting, and ample luggage space—ideal for corporate executives, elite families, or special events. Whether it’s airport transfers, wedding travel, or VIP guest movement, this luxury vehicle guarantees a smooth, quiet, and premium ride."
  },
  {
    "name": "AC Urbania Van Pune",
    "description": "Hire fully air-conditioned Force Urbania vans in Pune for comfortable travel in all seasons. These vans are equipped with modern cooling systems, high headroom, noise-insulated cabins, and USB charging ports. Perfect for small-to-medium-sized groups looking to travel together with luxury and practicality. Whether it's for weddings, airport transfers, or family road trips, our AC Urbania ensures a relaxed and elegant journey."
  },
  {
    "name": "Force Urbania for Wedding Pune",
    "description": "Make your wedding transportation both stylish and efficient with Force Urbania vans in Pune. Ideal for transporting close family members, VIP guests, or the bride/groom party, these vehicles add a premium touch to your wedding logistics. Decor options, uniformed drivers, and customized schedules are available. With luxury interiors and professional service, our Urbania vans ensure every wedding guest travels in class and comfort."
  },
  {
    "name": "Outstation Urbania Rental Pune",
    "description": "Book Urbania vans for outstation travel from Pune to any destination across Maharashtra and beyond. These premium vans are built for long road trips, offering unmatched comfort, high mileage, and strong suspension. Suitable for family vacations, temple tours, business roadshows, and group tourism. Our packages include fuel, driver, tolls, and flexible itinerary customization to make your outstation trip worry-free and enjoyable."
  },
  {
    "name": "Urbania for Corporate Use",
    "description": "Professional Urbania van rentals tailored for corporate clients in Pune. Ideal for transporting employees to conferences, offsite events, or daily staff movement in premium style. Vans come with GPS tracking, Wi-Fi (on request), and punctual drivers. With comfortable seating and a professional exterior, Force Urbania is the perfect transport solution for high-level business engagements and executive travel."
  },
  {
    "name": "Urbania for Tour Packages Pune",
    "description": "Explore Maharashtra and beyond with our Urbania van tour packages from Pune. Whether it’s Lonavala, Mahabaleshwar, Goa, or Shirdi, our vehicles are suited for scenic drives, hill station tours, and religious circuits. Tour packages include vehicle, driver, fuel, and optional sightseeing guides. Enjoy a smooth, spacious, and upscale travel experience for your group holiday with customizable departure times and routes."
  },
  {
    "name": "Family Travel Urbania Hire Pune",
    "description": "Travel with comfort and closeness by hiring a Force Urbania for your family trip in Pune. With 13 to 17 seater options, these vans are ideal for joint family vacations, destination weddings, or festival travel. Enjoy reclining seats, large luggage compartments, and onboard entertainment systems. Travel together without splitting into multiple cars and make the journey as memorable as the destination."
  },
  {
    "name": "13/17 Seater Luxury Urbania Pune",
    "description": "Choose between 13-seater or 17-seater luxury Urbania vans in Pune for mid-size group transportation. These vans offer the latest amenities like individual air vents, mood lighting, cushioned leather seats, and rear-view displays. Perfect for weddings, business travel, or VIP tourism. Whether you're heading out for a weekend getaway or hosting guests, these premium vans deliver style and substance."
  },
  {
    "name": "Urbania with Driver Pune",
    "description": "Rent Force Urbania vans with professional, uniformed drivers in Pune. Our drivers are background-verified, trained in hospitality, and familiar with both local and outstation routes. They ensure a smooth, punctual, and courteous travel experience. Ideal for those who want a complete, hands-free travel package. Available for short-term or multi-day rentals across the city and beyond."
  },
  {
    "name": "Wedding Urbania Van Rental",
    "description": "Specialized Urbania van rental for weddings in Pune, designed to transport bride/groom family, VIP guests, or even as a getaway vehicle. Options for floral decoration, wedding signage, and customized routes are available. Make your wedding logistics seamless with elegant, high-capacity, and reliable travel. Buses arrive early, drivers are event-trained, and your guests arrive in style."
  },
  {
    "name": "Business Urbania on Rent Pune",
    "description": "Corporate-grade Urbania van rentals in Pune for client meetings, seminars, business site visits, or partner logistics. These stylish vans leave a lasting impression and provide executive-level comfort. Includes billing support for GST, driver wait time, and last-mile drop-offs. Maintain your brand’s reputation with professional transport for business associates or internal teams."
  },
  {
    "name": "Pune Urbania Weekend Trip",
    "description": "Book Urbania vans for weekend getaways from Pune to nearby tourist spots like Lonavala, Alibaug, Mahabaleshwar, or Lavasa. Enjoy a relaxed journey with family or friends in a van built for scenic drives and hilly terrains. Comfortable seating, panoramic windows, and safety features ensure the journey is just as enjoyable as the destination. Available in both AC and luxury variants."
  },
  {
    "name": "Premium Urbania Hire Pune",
    "description": "Hire premium Force Urbania vans in Pune for top-tier personal or professional travel. Whether for international guests, political visits, or luxury events, these vans offer the finest travel experience with high-end interiors, entertainment systems, mood lighting, and plush ride quality. Professional chauffeurs ensure safe, discreet, and elite-level service throughout your rental period."
  }
],
"tableData": [
  ["Luxury Urbania Hire Pune", "AC Urbania Van Pune"],
  ["Force Urbania for Wedding Pune", "Outstation Urbania Rental Pune"],
  ["Urbania for Corporate Use", "Urbania for Tour Packages Pune"],
  ["Family Travel Urbania Hire Pune", "13/17 Seater Luxury Urbania Pune"],
  ["Urbania with Driver Pune", "Wedding Urbania Van Rental"],
  ["Business Urbania on Rent Pune", "Pune Urbania Weekend Trip"],
  ["Premium Urbania Hire Pune"]
],




"whychoose": [
  {
    "WhyChooseheading": "Luxury Force Urbania on Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers premium Force Urbania rentals in Pune, ideal for executive travel, family trips, and VIP transfers with unmatched comfort and style."
  },
  {
    "WhyChooseheading": "Modern and Premium Interiors",
    "WhyChoosedescription": "Experience luxurious travel with pushback leather seats, mood lighting, individual AC vents, and a smooth suspension system for a first-class ride."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "Each Urbania is regularly serviced, deep-cleaned, and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for Any Occasion",
    "WhyChoosedescription": "Whether it’s for business meetings, airport transfers, weddings, or long road trips — we offer hourly, daily, and custom rental packages."
  },
  {
    "WhyChooseheading": "Experienced and Professional Chauffeurs",
    "WhyChoosedescription": "Our uniformed drivers are trained, courteous, and experienced in handling VIP travel and Pune city routes with efficiency."
  },
  {
    "WhyChooseheading": "Transparent Pricing and Hassle-Free Booking",
    "WhyChoosedescription": "No hidden charges — our pricing includes fuel, tolls, taxes, and driver allowance for a seamless experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Wedding, and Luxury Travel",
    "WhyChoosedescription": "Perfect for luxury wedding entries, high-end group outings, corporate guest transport, and celebrity travel in Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support & Assistance",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to help with bookings, route planning, and travel queries."
  }
]















  }







const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer Luxury Force Urbania on rent in Pune?',
      answer: 'Yes, Vaishnavi Travels provides Luxury Force Urbania vehicles on rent in Pune, ideal for comfortable and stylish group travel, corporate outings, and special occasions.',
    },
    {
      question: 'What are the seating capacities of Luxury Force Urbania available for rent?',
      answer: 'Our Luxury Force Urbania vehicles typically seat 9 to 12 passengers, offering spacious and plush interiors for a premium travel experience.',
    },
    {
      question: 'Are the Luxury Force Urbania vehicles air-conditioned and well-maintained?',
      answer: 'Absolutely. All our Luxury Force Urbania vehicles are fully air-conditioned, regularly serviced, and maintained to ensure maximum comfort and safety.',
    },
    {
      question: 'What is the approximate rental cost for Luxury Force Urbania in Pune?',
      answer: 'Rental costs start from ₹3,500 for half-day local use. Rates vary depending on duration, distance, and specific requirements. Customized quotes are available on request.',
    },
    {
      question: 'Do rentals include professional drivers?',
      answer: 'Yes, all rentals come with experienced and courteous drivers who prioritize your comfort and safety throughout the journey.',
    },
    {
      question: 'Can I book Luxury Force Urbania for outstation trips from Pune?',
      answer: 'Certainly. We offer outstation packages with Luxury Force Urbania, including day trips and multi-day journeys with transparent pricing.',
    },
    {
      question: 'How far in advance should I book a Luxury Force Urbania?',
      answer: 'Booking at least 2-3 days in advance is recommended, especially during weekends and peak seasons, to ensure availability.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Karan Mehta",
    position: "Event Coordinator",
    feedback:
      "Vaishnavi Travels provided a Luxury Force Urbania for our corporate client transfer. The vehicle was immaculate, comfortable, and the driver was professional and punctual. Great service overall!",
    rating: 5,
  },
  {
    name: "Mrs. Sneha Joshi",
    position: "Family Trip Organizer",
    feedback:
      "We rented a Luxury Force Urbania for a weekend getaway. The ride was smooth, interiors were luxurious, and the driver was friendly and helpful. Highly recommend Vaishnavi Travels for luxury vehicle rentals.",
    rating: 5,
    style: "style-2",
  }
];




























































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania on Rent in Pune",
  "image": "https://vaishnavitravel.com/assets/images/luxury-force-urbania-pune.jpg",
  "description": "Rent Luxury Force Urbania in Pune with Vaishnavi Travels. Ideal for weddings, outstation trips, corporate events, and family tours. Choose 13 or 17 seater AC Urbania vans with driver.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "820"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4800",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/luxury-force-urbania-on-rent-in-pune"
  }
};




  return (
    <div>


<Helmet>
  <title>Luxury Force Urbania on Rent in Pune | 13 & 17 Seater Urbania Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Rent Luxury Force Urbania in Pune with Vaishnavi Travels. Ideal for weddings, outstation trips, corporate events, and family tours. Choose 13 or 17 seater AC Urbania vans with driver."
  />
  <meta
    name="keywords"
    content="Luxury Urbania Hire Pune, AC Urbania Van Pune, Force Urbania for Wedding Pune, Outstation Urbania Rental Pune, Urbania for Corporate Use, Urbania for Tour Packages Pune, Family Travel Urbania Hire Pune, 13/17 Seater Luxury Urbania Pune, Urbania with Driver Pune, Wedding Urbania Van Rental, Business Urbania on Rent Pune, Pune Urbania Weekend Trip, Premium Urbania Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryforceurbaniaonrentinpune;